import { useState } from "react";
import { api } from "../../lib/apiClient";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function ChangePasswordModal() {
  const { user, setUserExternal } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (next.length < 6) { toast.error("Minimum 6 characters"); return; }
    if (next !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setUserExternal && setUserExternal({ ...user, must_change_password: false });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  }

  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-6" data-testid="change-password-modal">
      <form onSubmit={submit} className="bg-[#12182B] border border-[#D4AF37]/30 rounded-xl p-6 w-full max-w-md">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 mx-auto flex items-center justify-center text-[#D4AF37]">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <div className="font-display text-2xl mt-4">Secure your account</div>
          <p className="text-white/60 text-sm mt-2">You're using a temporary password. Please set a new one to continue.</p>
        </div>
        <div className="space-y-4">
          <Field label="Current (temporary) password">
            <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="input" data-testid="cp-current" />
          </Field>
          <Field label="New password">
            <input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} className="input" data-testid="cp-new" />
          </Field>
          <Field label="Confirm new password">
            <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input" data-testid="cp-confirm" />
          </Field>
        </div>
        <button type="submit" disabled={loading} className="btn-gold w-full rounded-md py-3 mt-6 disabled:opacity-60" data-testid="cp-submit">
          {loading ? "Updating…" : "Set new password"}
        </button>
        <style>{`.input { width: 100%; background: #0a0f1c; border: 1px solid rgba(255,255,255,0.08); border-radius: 6px; padding: 10px 12px; color: #F8F9FA; font-size: 14px; outline: none; } .input:focus { border-color: rgba(212, 175, 55, 0.6); }`}</style>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-white/50 mb-2">{label}</div>
      {children}
    </div>
  );
}
